import { tss } from 'tss-react/mui';

export const useHeroStyles = tss.withName('HeroSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        paddingTop: theme.spacing(14),
        paddingBottom: theme.spacing(10),
        overflow: 'hidden',
    },
    inner: {
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto',
        padding: theme.spacing(0, '6%'),
        display: 'grid',
        gridTemplateColumns: '7fr 5fr',
        gap: theme.spacing(6),
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr',
            gap: theme.spacing(6),
        },
    },
    eyebrow: {
        display: 'inline-flex',
        alignItems: 'center',
        border: `1px solid ${theme.palette.lineOnDark}`,
        borderRadius: 999,
        padding: theme.spacing(0.75, 2),
        marginBottom: theme.spacing(3.5),
        color: theme.palette.fog,
    },
    headline: {
        marginBottom: theme.spacing(3.5),
    },
    subCopy: {
        maxWidth: 480,
        color: theme.palette.fog,
        marginBottom: theme.spacing(5),
    },
    ctaRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(4),
    },
    secondaryLink: {
        color: theme.palette.ink.contrastText,
        textDecoration: 'none',
        fontSize: '0.9rem',
        fontWeight: 500,
        borderBottom: `1px solid ${theme.palette.lineOnDark}`,
        paddingBottom: 2,
        transition: 'border-color 0.3s ease',
        '&:hover': {
            borderColor: theme.palette.ink.contrastText,
        },
    },
    visual: {
        position: 'relative',
        height: 420,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            height: 280,
        },
    },
}));
